import React from "react";
import { stepEightData } from "../stepData";
import { Typography } from "@mui/material";
import tongueOut from "../../../../../../Assets/Images/tongue-out.webp";

const StepEight = () => {
  return (
    <>
      <div>
        <div className=" mt-3 d-flex flex-column gap-3">
          <Typography
            sx={{
              fontSize: "23.8532px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepEightData[0].heading}
          </Typography>
        </div>
        <ol
          style={{
            listStyle: "number",
            fontSize: 16,
            lineHeight: "24px",
            letterSpacing: "0.08px",
            fontWeight: 500,
            fontFamily: "'Archivo',sans-serif",
          }}
          className="mt-3"
        >
          <li className="mt-2">
            Choose a longer tenure if you need a lower EMI.
          </li>
          <li className="mt-2">
            Make a higher down payment to reduce the loan amount.
          </li>
          <li className="mt-2">
            Opt for a bank with the lowest APR instead of just the lowest
            interest rate.
          </li>
          <li className="mt-2">
            Improve your credit score before applying to negotiate better terms.
          </li>
        </ol>
        <div className="tips mt-4 ">
          <div id="border_line"></div>
          <div id="tip__container" className="px-2 px-sm-4 py-4">
            <div className="px-3 py-2">
              <div className="d-flex flex-row gap-2 align-items-center">
                <img src={tongueOut} alt="" style={{ width: 30, height: 30 }} />
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#59266D",
                    // color: "yellow",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  MinEmi Tip:
                </Typography>
              </div>
              <div className="mt-2">
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#1F1F1F",

                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  {stepEightData[0].tip}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepEight;
